module.exports = __webpack_public_path__ + "static/media/objects2_07.372578f4.svg";